import { render } from "./ClinicFormData.vue?vue&type=template&id=95511de6&scoped=true"
import script from "./ClinicFormData.vue?vue&type=script&lang=js"
export * from "./ClinicFormData.vue?vue&type=script&lang=js"

import "./ClinicFormData.vue?vue&type=style&index=0&id=95511de6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95511de6"]])

export default __exports__